import DesktopCalendar from '@/containers/Desktop/DesktopCalendar';
import { setShowCalendarVietNam } from '@/slices/calendar/calendarSlice';
import { useLazyGetFlightStatisticsQuery } from '@/slices/flightData/apis/flightDataApi';
import { TGenerateFlightCountRequest } from '@/utils/generateFlightRequest';
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import { isEmpty } from 'lodash';
import React, { useEffect } from 'react';
import { getMappingDatePriceDataCalendar } from '../RouteCompanyCityToCity/SectionManager';
import { getRangeCountTet } from '../RoutePage/SectionManager/utils';

// Component

function CalendarFareNewYearVcms(props: any) {
  const {
    selectedDate, dayTetPriceObjs, onSearchFlight, findDayNewYear, isLoading, lang,
  } = props;

  // const [getTetMinFare, { data, isFetching: isLoadingClient }] = useLazyGetFlightStatisticsQuery();

  // const startPoint = useAppSelector((state) => state.searchFlightForm.startPointHome);
  // const toPoint = useAppSelector((state) => state.searchFlightForm.toPointHome);
  const isShowCalendarVietNam = useAppSelector(
    (state) => state.calendar.showCalendarVietNam,
  );
  // const fromAirports = startPoint?.airports?.map((airport: any) => airport.airportCode) || [];
  // const toAirports = toPoint?.airports?.map((airport: any) => airport.airportCode) || [];

  // const { startDate, endDate } = getRangeCountTet();

  // const flightTetRequestStatistics: TGenerateFlightCountRequest = {
  //   from: fromAirports,
  //   to: toAirports,
  //   date_range: {
  //     min: startDate,
  //     max: endDate,
  //   },
  //   is_count_tet_price: 1,
  //   flight_class: 'PT',
  //   // airline: [companySlug as any],
  // };

  // useEffect(() => {
  //   console.log(startPoint, 'startPoint');
  //   if (!startPoint || !toPoint) {
  //     return;
  //   }
  //   getTetMinFare(flightTetRequestStatistics);
  // }, [startPoint, toPoint, getTetMinFare]);

  // const dispatch = useAppDispatch();

  // useEffect(() => {
  //   setTimeout(() => {
  //     dispatch(setShowCalendarVietNam({ value: true }));
  //   }, 1500);
  // }, []);
  const dayPriceObj = !isEmpty(dayTetPriceObjs) ? dayTetPriceObjs : null;
  return (
    <DesktopCalendar
      lang={lang}
      disableChangeMonth
      limit={1}
      isLunarYearMode={isShowCalendarVietNam}
      // isLoading={isLoadingClient}
      isDisableRoundTrip
      type="depart"
      dayPriceObj={dayPriceObj}
      selectedDate={{
        depart: new Date(findDayNewYear?.date),
        return: null,
      }}
      setSelectedDateFunc={onSearchFlight}
    />
  );
}

export default React.memo(CalendarFareNewYearVcms);
